import { lazy } from 'react-loosely-lazy';
import type { CheckboxSelectEdit } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncCheckboxSelectEdit = lazy<typeof CheckboxSelectEdit>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-checkbox-select-edit" */ './index').then(
		(module) => module.CheckboxSelectEdit,
	),
);
